import { render } from "./MobileBox.vue?vue&type=template&id=1cc520a4&scoped=true"
import script from "./MobileBox.vue?vue&type=script&lang=js"
export * from "./MobileBox.vue?vue&type=script&lang=js"

import "./MobileBox.vue?vue&type=style&index=0&id=1cc520a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc520a4"]])

export default __exports__